import React from 'react';
import { Audio } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) =>
  <Audio
    {...props}
    src={generateUrl(file_audio_id)}
  />
;